const keyChars = 'ABCDEFGHIJKLMNPQRSTUVWXYZ123456789';
var maxLength = keyChars.length - 1

const getRandomInt = (max, min = 1) => Math.floor(Math.random() * max) + min;

const keyGen = (length = 4) => {
    if (length < 1 || length > 20) throw new Error('Invalid length - valid range is 1 to 20');

    var result = ''
    for (var i = 1; i <= length; i++) {
        result += keyChars[getRandomInt(maxLength)]
    }
    return result;
}

export { keyGen, getRandomInt };
